import {
	Component,
	Input,
	ViewEncapsulation,
	Output,
	EventEmitter,
	Host,
	Optional,
	HostBinding,
	OnDestroy
} from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { ExpandableContainerComponent } from '../expandable-container/expandable-container.component';
import { TExpandableArrowAlign, TExpandableArrowPosition } from './expandable.types';

@Component({
	selector: 'rbc-expandable',
	templateUrl: './expandable.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./expandable.component.scss']
})
export class ExpandableComponent implements OnDestroy {
	@HostBinding('id') @Input() id: string;
	@Input() expanded: boolean = false;
	@Input() arrow: boolean = false;
	@Input() arrowPosition: TExpandableArrowPosition = 'right';
	@Input() arrowAlign: TExpandableArrowAlign = 'top';
	@Input() duration: number;
	@Input() toggleShow: boolean = false;
	@Input() hostClass: string | string[];

	// Output Parameters
	@Output() expandclose = new EventEmitter();
	@Output() expandopen = new EventEmitter();

	constructor(private idService: IdService, @Optional() @Host() private host: ExpandableContainerComponent) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	toggle() {
		this.expanded = !this.expanded;

		if (this.expanded) {
			this.expandopen.emit(this.id);
		} else {
			this.expandclose.emit(this.id);
		}

		if (this.host) {
			this.host.childExpanded(this.id, this.expanded);
		}
	}
}
